export var revenueAUMDataMapper = function (response) {
    var totalInvestedValues = 0, totalMarketValues = 0, totalPercentages = 0;
    if (response) {
        return {
            requestId: response.requestid,
            success: response.success,
            message: response.message,
            statusCode: response.statuscode,
            errors: response.errors,
            currentPage: response.currentpage,
            pageSize: response.pagesize,
            totalPages: response.totalpages,
            totalItems: response.totalitems,
            orderBy: response.orderby,
            orderByDesc: response.orderbydesc,
            data: response.data.length > 0
                ? response.data.map(function (item) {
                    totalInvestedValues += item.investedValue,
                        totalMarketValues += item.marketValue,
                        totalPercentages += Number(item.totalHoldingPercent);
                    return {
                        dataTarget: item.dataTarget,
                        productName: item.productName,
                        shortproductName: item.shortproductName,
                        investedValue: item.investedValue,
                        marketValue: item.marketValue,
                        dreturn: item.dreturn,
                        totalHoldingPercent: item.totalHoldingPercent,
                        Opentask: item.Opentask,
                        iIsShow: item.iIsShow,
                        aumInsuranceData: [],
                        summaryAumData: [],
                    };
                })
                : [],
            totalInvestedValue: totalInvestedValues != null ? totalInvestedValues : 0,
            totalMarketValue: totalMarketValues != null ? totalMarketValues : 0,
            totalDReturn: totalInvestedValues != 0 ? (((totalMarketValues - totalInvestedValues) * 100) / totalInvestedValues) : 0,
            totalPercentage: (Number(totalPercentages) < 100 ? Number(totalPercentages) : (Number(totalPercentages) >= 100 ? 100 : Number(totalPercentages))),
        };
    }
    return {};
};
